export const isValidEmail = (email?: string) => /^\S+@\S+\.\S+$/.test(email ?? '');

export const isValidPhone = (phone?: string) => /^\+?[0-9\s\-().]{7,}$/.test(phone ?? '');

export function extractContactInfo(input: string = '') {
  const emailRegex = /\b\S+@\S+\.\S+\b/;
  const phoneRegex = /\+?[0-9\s\-().]{7,}/;

  const emailMatch = input.match(emailRegex);
  const phoneMatch = input.match(phoneRegex);

  return {
    email: emailMatch ? emailMatch[0] : null,
    phone: phoneMatch ? phoneMatch[0] : null,
  };
}
